import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";

export const TaskPlanPage = () => (
  <PageLayout pageTitle="Aufgabe planen">
    <p className="p-6 text-gray-400 text-sm">
      Die Aufgabenplanung wird derzeit neu aufgebaut.
    </p>
  </PageLayout>
);
